/**
 * Narrow entry point for transaction-level leader-change replay.
 *
 * Separate from the main barrel for the same reason as `+busy-retry.ts`: the
 * barrel drags in expo-sqlite/Turso machinery, while this module depends only on
 * the pure `errors` subpath of the leader package — so `wrap-actor-database.ts`
 * (which the server bundle also reaches) can import it safely.
 */
export {
  DEFAULT_LEADER_CHANGE_REPLAY_ATTEMPTS,
  isLostCommitLeaderChangeError,
  isReplayableLeaderChangeError,
  markLeaderChangeNotReplayable,
  retryOnLeaderChange,
  type LeaderChangeReplayOptions,
} from "#leader-transaction-replay";
